module.exports = __webpack_public_path__ + "img/April Weaver.cbaf4496.jpg";